import api from './api';
import { resolvePhotoUrl } from './photoUrl';

// The server files the upload under dna/{dnaId}/ -- the record's permanent id,
// never a name this client chose. It used to send the isolate code and have
// the server slug it into the folder name, which let two isolates share one.
export async function uploadDnaFile(file, dnaId, geneName, fileRole) {
  const presignRes = await api.post('/dna/sequencing-runs/presign', {
    filename: file.name,
    content_type: file.type || 'application/octet-stream',
    dna_id: dnaId,
    gene_name: geneName || '',
    file_role: fileRole,
  });
  const { presign_url, s3_key, s3_url } = presignRes.data;
  // On the desktop the URL names 127.0.0.1 -- the phone itself, on a phone.
  // Re-based onto the server this client talks to, signature and all.
  const target = resolvePhotoUrl(presign_url);

  let s3Res = await fetch(target, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
  });
  if (!s3Res.ok) {
    s3Res = await fetch(target, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
    });
    if (!s3Res.ok) {
      throw new Error(`S3 upload failed (HTTP ${s3Res.status})`);
    }
  }

  return { s3_url, s3_key };
}
